/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyUserRequest
 */
export interface VerifyUserRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyUserRequest
     */
    accessToken?: string | null;
}

/**
 * Check if a given object implements the VerifyUserRequest interface.
 */
export function instanceOfVerifyUserRequest(value: object): value is VerifyUserRequest {
    return true;
}

export function VerifyUserRequestFromJSON(json: any): VerifyUserRequest {
    return VerifyUserRequestFromJSONTyped(json, false);
}

export function VerifyUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'] === undefined ? undefined : json['accessToken'] === null ? null : json['accessToken'],
    };
}

export function VerifyUserRequestToJSON(json: any): VerifyUserRequest {
    return VerifyUserRequestToJSONTyped(json, false);
}

export function VerifyUserRequestToJSONTyped(value?: VerifyUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
    };
}

